import React from "react";

interface IDropdownQuestionProps {
  id: string;
  labelText: string;
  name: string;
  defaultValue: string;
  onChange: (e: any) => void;
  options: Answer[];
  validationMessage: string | null;
  defaultOptionText?: string;
  noOptionValue?: number
}

export default function DropdownQuestion({
  id,
  labelText,
  name,
  defaultValue,
  onChange,
  options,
  validationMessage,
  defaultOptionText,
  noOptionValue
}: IDropdownQuestionProps) {
  return (
    <>
      <div className="ch-form__group ch-pb--1 ">
        <label htmlFor={id} className="ch-form__control-label ch-pb--1">
          {labelText}
        </label>
        {validationMessage && (
          <p className="dropdown-validation">{validationMessage}</p>
        )}
        <div
          className={`ch-form__group ${
            validationMessage ? "ch-form__group--error" : ""
          } md:ch-width--7 sm:ch-width--12`}
        >
          <select
            id={id}
            name={name}
            className="ch-form__control custom-dropdown"
            defaultValue={defaultValue || "no-answer"}
            onChange={onChange}
          >
            {defaultOptionText && (
              <option value={noOptionValue || "no-answer"}>{defaultOptionText}</option>
            )}
            {options?.map((option: Answer) => (
              <option key={option.id} value={option.id}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
}
